import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StayUpdated() {
  return <section id="håll-dig-uppdaterad" className="py-24 bg-gradient-to-b from-background to-accent">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-10">
          Är du redo för revolutionen?
        </h2>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
          <Button asChild size="lg" className="rounded-[3px] w-full sm:w-auto text-base px-8">
            <Link to="/BecomeOperatorPage">
              Bli Operatör
            </Link>
          </Button>
          <Button asChild size="lg" className="rounded-[3px] w-full sm:w-auto text-base px-8">
            <Link to="/CheaperInsurancePage">
              Billigare Försäkring
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}